<section class="section banner">
    <div class="container">
        <div class="section-box-banner">
            <div class="content">
                <div class="banner-pretitle">
                    <h1>{{"Banner.Pretitle" | translate}}</h1>
                </div>
                <div class='banner-title'>
                    <h2 class="banner-name" [innerHTML]="'Banner.Name' | translate"></h2>
                    <h3 class="banner-subtitle" [innerHTML]="'Banner.Subtitle' | translate"></h3>
                </div>
                <div class='banner-description'>
                    <p [innerHTML]='"Banner.Description" | translate' class="mt-4"></p>
                </div>
            </div>
            <div class="div-btn-banner">
                <app-dynamic-button
                    [text]='"Banner.ActionBtn" | translate'
                    href="mailto:juandavid.dev00@outlook.com"
                    target="_blank"
                    analyticsEvent="click_send_mail"
                    analyticsCategory="banner"
                    analyticsLabel="email"
                    variant="primary">
                </app-dynamic-button>
            </div>
        </div>
    </div>


</section>
